import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=efe7dfca&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe7dfca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efe7dfca')) {
      api.createRecord('efe7dfca', component.options)
    } else {
      api.reload('efe7dfca', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=efe7dfca&scoped=true&", function () {
      api.rerender('efe7dfca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2msjqBzMYW8He/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports